const MONTH_DAYS = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31]
const LEAP_YEAR_MONTH_DAYS = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31]

export const getDaysInSolarYear = year => {
  if (isLeapYear(year)) {
    return 366
  } else {
    return 365
  }
}

export const isLeapYear = year => {
  return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0
}

export const getSolarMonthDays = (year, month) => {
  return isLeapYear(year)
    ? LEAP_YEAR_MONTH_DAYS[month - 1]
    : MONTH_DAYS[month - 1]
}

export const getDaysOfSolarYearToDate = dt => {
  const y = dt.getFullYear()
  const m = dt.getMonth()
  let i = 0
  let days = 0
  let daysList = MONTH_DAYS
  if (isLeapYear(y)) {
    daysList = LEAP_YEAR_MONTH_DAYS
  }
  while (i < m) {
    // console.log("getDaysOfSolarYearToDate => date: "+dt+", m: "+m)
    days += daysList[i]
    i++
  }
  return days + dt.getDate() - 1
}
